import { request } from "@umijs/max";

export async function login(body: API.LoginParams) {
    try {
        const response = await request<any>('/user/login', {
            method: 'POST',
            data: body,
        });

        return response;
    } catch (error) {
        console.error('Error during login request:', error);
        throw new Error('Login request failed');
    }
}

export async function register(body: any) {
    try {
        return request<any>('/user/register', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during register request:', error);
        throw new Error('Register request failed');
    }
}

export async function sendVerificationCodeEmail(body: { email: string; fullName: string }) {
    try {
        return request<any>('/user/email/send-verification-code', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during send verification code request:', error);
        throw error;
    }
}

export async function sendVerificationCodePhone(body: { phoneNumber: string; fullName: string, countryCode: string }) {
    try {
        return request<any>('/user/phone/send-verification-code', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during send verification code request:', error);
        throw error;
    }
}

export async function verifyPhoneOtp(body: { phoneNumber: string; otp: string }) {
    try {
        return request<any>('/user/phone/verify-code', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during verify OTP request:', error);
        throw error;
    }
}

export async function verifyEmailOtp(body: { email: string; otp: string }) {
    try {
        return request<any>('/user/email/verify-code', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during verify OTP request:', error);
        throw error;
    }
}

export async function currentUser() {
    return request<{ data: API.CurrentUser }>('/user/api/currentUser', {
        method: 'GET'
    });
}

export async function logout() {
    return request('/user/logout', {
        method: 'POST'
    });
}

export async function checkUserExists(body: { email: string; phoneNumber: string }) {
    try {
        return request<any>('/user/check-user-exists', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during check user exists request:', error);
        throw error;
    }
}

export async function updateUserProfile(body: { phoneNumber: string }) {
    try {
        return request<any>('/user/update-profile', {
            method: 'POST',
            data: body,
        });
    } catch (error) {
        console.error('Error during update profile request:', error);
        throw error;
    }
}

export async function googleAuth(credential: string, phoneNumber?: string) {
    try {
        return request<any>('/user/google-auth', {
            method: 'POST',
            data: { credential, phoneNumber },
        });
    } catch (error) {
        console.error('Error during Google authentication:', error);
        throw error;
    }
}

export async function microsoftAuth(idToken?: string, phoneNumber?: string, accessToken?: string) {
    try {
        console.log(`Microsoft Auth - Sending ${accessToken ? 'access token' : 'id token'} to backend`);
        
        // Use access token authentication (preferred method)
        if (accessToken) {
            return request<any>('/user/microsoft-auth', {
                method: 'POST',
                data: { accessToken, phoneNumber },
            });
        }
        
        // Legacy id token authentication (fallback)
        if (idToken) {
            return request<any>('/user/microsoft-auth', {
                method: 'POST',
                data: { idToken, phoneNumber },
            });
        }
        
        console.error('Microsoft Auth: No authentication token provided');
        throw new Error('No authentication token provided');
    } catch (error) {
        console.error('Error during Microsoft authentication:', error);
        throw error;
    }
}

export async function exchangeMicrosoftCode(code: string, codeVerifier: string, redirectUri: string) {
    try {
        console.log('Exchanging code for token with:', {
            code: code.substring(0, 10) + '...',
            codeVerifier: codeVerifier.substring(0, 10) + '...',
            redirectUri
        });
        
        const tokenEndpoint = 'https://login.microsoftonline.com/common/oauth2/v2.0/token';
        const clientId = '146fc7db-2bc4-41f6-8289-0ea268e125ec'; // Your client ID
        
        const formData = new URLSearchParams();
        formData.append('client_id', clientId);
        formData.append('scope', 'openid profile email User.Read');
        formData.append('code', code);
        formData.append('redirect_uri', redirectUri);
        formData.append('grant_type', 'authorization_code');
        formData.append('code_verifier', codeVerifier);
        
        console.log('Sending token request...');
        const response = await fetch(tokenEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            console.error('Token exchange failed:', errorText);
            throw new Error(`Failed to exchange code for tokens: ${errorText}`);
        }
        
        const tokenData = await response.json();
        console.log('Token exchange response received');
        
        // This should include access_token, id_token, and refresh_token
        return tokenData;
    } catch (error) {
        console.error('Error exchanging code for tokens:', error);
        throw error;
    }
}

export async function checkBurnerEmail(email: string) {
    try {
        return request<any>('/user/is-burner-email', {
            method: 'POST',
            data: { email },
        });
    } catch (error) {
        console.error('Error checking if email is burner:', error);
        throw error;
    }
}

export async function isWhatsappServiceRunning() {
    try {
        return request<any>('/user/phone/is-whatsapp-service-running', {
            method: 'GET',
        });
    } catch (error) {
        console.error('Error checking if WhatsApp service is running:', error);
        return { running: false };
    }
}
